// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-ece6f782] {\n  margin: 0 0 1.2rem 0;\n}\ndiv.tile.is-parent[data-v-ece6f782] {\n  min-height: calc(100vh - 8rem);\n}\n.main-container > .field[data-v-ece6f782] {\n  margin-bottom: 1.5rem;\n}\n.is-disabled[data-v-ece6f782] {\n  pointer-events: none;\n  opacity: 0.6;\n}", ""]);
// Exports
module.exports = exports;
